export function getApiErrorMessage(error) {
  // This is a really naive implementation and maybe we should
  // do something better!
  return error?.response?.data?.message || String(error);
}
